import React from "react";

import { Container } from "./styles";

const Stepper = props => (
  <Container className="stepper">{props.children}</Container>
);

export default Stepper;
